import { spreadCoordinate } from './meetingMapGeocode';

/** Build best geocode query for a hotel/property */
export const buildHotelGeocodeQuery = (hotel, searchLocation = '') => {
  const parts = [
    hotel.address,
    hotel.city,
    searchLocation,
    'India',
  ]
    .map((p) => String(p || '').trim())
    .filter(Boolean);
  const unique = [...new Set(parts)];
  if (hotel.name && searchLocation) {
    return `${hotel.name}, ${unique.join(', ')}`;
  }
  return unique.join(', ');
};

const COORD_PRECISION = 2;

const coordKey = (lat, lng) =>
  `${Number(lat).toFixed(COORD_PRECISION)},${Number(lng).toFixed(COORD_PRECISION)}`;

/** Spread pins that share the same rounded coordinates so they don't stack */
export const spreadOverlappingCoordinates = (items) => {
  if (!items.length) return items;

  const groups = new Map();
  items.forEach((item, index) => {
    const key = coordKey(item.lat, item.lng);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push({ item, index });
  });

  return items.map((item, index) => {
    const key = coordKey(item.lat, item.lng);
    const group = groups.get(key) || [];
    if (group.length <= 1) return item;
    const posInGroup = group.findIndex((g) => g.index === index);
    const spread = spreadCoordinate(item.lat, item.lng, posInGroup, group.length);
    return { ...item, lat: spread.lat, lng: spread.lng };
  });
};
